import React, {Fragment, useState} from 'react';
import createForm from "./Form";
import ComponentField from "../../form/ComponentField";
import {BarcodeFormatter, UnitFormatter} from "../../../utils/formatters";
import {connect} from "src/store";
import DataGrid from "../../form/SelectorGrid/DataGrid";
import Confirm, {smallDeleteProps} from "../../form/Confirm";
import Select from "../../form/Select";
import TextInput from "../../form/TextInput";
import {ifCompletedInput} from "../../../utils/other";

const sortable = true;
const filterable = true;

const AddModal = ({onAccept, id}) => {
    let [item, setItem] = useState({});
    return <Confirm
        size="medium"
        color="primary"
        buttonSize="xs"
        body={<Fragment>
            <div className="row">
                <div className="col-md-12">
                    <div className="form-group">
                        <Select
                            label="Termék"
                            component="product"
                            value={item.product}
                            storeType="remote"
                            name="product"
                            autoSelect={true}
                            searchFormatter={BarcodeFormatter}
                            placeholder="Vonalkód vagy cím"
                            saveChanges={(field, value) => {
                                item = {...item};
                                item[field] = value;
                                setItem(item);
                            }}
                        />
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group unit">
                        <TextInput
                            name="qty"
                            type="number"
                            label="Mennyiség"
                            formatter={UnitFormatter}
                            value={item.qty}
                            saveChanges={(field, value) => {
                                item = {...item};
                                item[field] = value;
                                setItem(item);
                            }}
                        />
                    </div>
                </div>
            </div>
        </Fragment>}
        header="Termék hozzáadás"
        icon={{lib: "fa", name: "plus"}}
        acceptButton={id ? "Foglalás" : "Hozzáadás"}
        onAccept={async () => {
            await onAccept({...item});
            setItem({});
        }}
    />
}

class StockReservationForm extends React.Component<any, any> {

    render() {
        const items = this.props.values.items || [];
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-md-2">
                        <div className="form-group">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name={this.props.componentConfig.idfield}
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Kód"
                            />
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="form-group">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="label"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Címke"
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="col-md-5">
                        <div className="form-group">
                            <ComponentField
                                getFieldProps={this.props.getFieldProps}
                                componentConfig={this.props.componentConfig}
                                name="store"
                                component="location"
                                filter={[{field: "partner", value: this.props.partner.partner_id}]}
                                storeType="local"
                                values={this.props.values}
                                setFieldValue={this.props.setFieldValue}
                                label="Raktár"
                                required={true}
                            />
                        </div>
                    </div>
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Termékek <span className="invalid-feedback">*</span></label>
                            {
                                this.props.values[this.props.componentConfig.idfield]
                                ?
                                <DataGrid
                                    componentConfig={this.props.componentConfig}
                                    data={this.props.values}
                                    name="items"
                                    view={["product.id"]}
                                    fields={{
                                        "actions": {
                                            props: {
                                                label: false,
                                                header: ({addItems}) => <AddModal
                                                    id={this.props.values[this.props.componentConfig.idfield]}
                                                    onAccept={(item) => {
                                                        addItems([item]);
                                                    }}
                                                />,
                                                width: "auto",
                                                formatter: ({row, removeItems}) => {
                                                    return <Confirm
                                                        {...smallDeleteProps}
                                                        onAccept={() => {
                                                            removeItems([row]);
                                                        }}
                                                    />
                                                }
                                            }
                                        },
                                        "product.displayname": {
                                            props: {
                                                header: 'Megnevezés',
                                                width: 3,
                                                sortable,
                                                filterable,
                                            }
                                        },
                                        "product.barcode": {
                                            props: {
                                                header: 'Vonalkód',
                                                width: 1,
                                                sortable,
                                                filterable,
                                            }
                                        },
                                        "product.sku": {
                                            props: {
                                                header: 'ISBN',
                                                width: 1,
                                                sortable,
                                                filterable,
                                            }
                                        },
                                        "qty": {
                                            props: {
                                                header: 'Mennyiség',
                                                width: 1,
                                                className: "unit",
                                                formatter: ({value}) => {
                                                    return UnitFormatter(value);
                                                },
                                                sortable,
                                                filterable,
                                            }
                                        }
                                    }}
                                />
                                :
                                <DataGrid
                                    value={this.props.values.items}
                                    addItems={(newItems) => {
                                        this.props.setFieldValue("items", [...items, ...newItems]);
                                    }}
                                    editItems={(editedItems) => {
                                        let list = [...items];
                                        editedItems.map((item) => {
                                            list[(item.idx || 1)-1] = {...item};
                                        });
                                        this.props.setFieldValue("items", list);
                                    }}
                                    removeItems={(removedItems) => {
                                        removedItems = removedItems.map((data) => data.idx-1);
                                        this.props.setFieldValue("items", items.filter(function (value, index) {
                                            return removedItems.indexOf(index) === -1;
                                        }));
                                    }}
                                    fields={{
                                        "actions": {
                                            props: {
                                                label: false,
                                                header: <AddModal
                                                    id={this.props.values[this.props.componentConfig.idfield]}
                                                    onAccept={(item) => {
                                                        this.props.setFieldValue("items", [...items, item]);
                                                    }}
                                                />,
                                                width: "auto",
                                                formatter: ({removeItems, rowIndex}) => {
                                                    return <Confirm
                                                        {...smallDeleteProps}
                                                        onAccept={() => {
                                                            removeItems([{idx: rowIndex}]);
                                                        }}
                                                    />
                                                }
                                            }
                                        },
                                        "product.displayname": {
                                            props: {
                                                header: 'Megnevezés',
                                                width: 3,
                                                sortable,
                                                filterable,
                                                formatter: ({row, editItems, rowIndex}) => {
                                                    return <Select
                                                        label={false}
                                                        component="product"
                                                        value={row.product}
                                                        storeType="remote"
                                                        name="product"
                                                        searchFormatter={BarcodeFormatter}
                                                        placeholder="Vonalkód vagy cím"
                                                        saveChanges={(field, value) => {
                                                            let item = {...row};
                                                            item[field] = value;
                                                            item.idx = rowIndex;
                                                            editItems([item]);
                                                        }}
                                                    />
                                                }
                                            }
                                        },
                                        "product.barcode": {
                                            props: {
                                                header: 'Vonalkód',
                                                width: 1,
                                                sortable,
                                                filterable
                                            }
                                        },
                                        "product.sku": {
                                            props: {
                                                header: 'ISBN',
                                                width: 1,
                                                sortable,
                                                filterable,
                                            }
                                        },
                                        "qty": {
                                            props: {
                                                header: 'Mennyiség',
                                                width: 1,
                                                sortable,
                                                filterable,
                                                className: "unit",
                                                formatter: ({value, row, editItems, rowIndex}) => {
                                                    return <TextInput
                                                        name="qty"
                                                        type="number"
                                                        label={false}
                                                        placeholder="Mennyiség"
                                                        formatter={UnitFormatter}
                                                        value={value}
                                                        onKeyDown={(e, field, value) => {
                                                            if (ifCompletedInput(e)) {
                                                                let item = {...row};
                                                                item[field] = value;
                                                                item.idx = rowIndex;
                                                                editItems([item]);
                                                            }
                                                        }}
                                                        onBlur={(e, field, value) => {
                                                            let item = {...row};
                                                            item[field] = value;
                                                            item.idx = rowIndex;
                                                            editItems([item]);
                                                        }}
                                                    />
                                                }
                                            }
                                        }
                                    }}
                                />
                            }
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default connect((state) => {
    return {
        partner: state.app.context.partner
    };
}, {})(createForm(StockReservationForm));
